import { SerpSeasonPlanSnapshot } from '@/components/Approval/@components/SerpSeasonPlan';
import { parseSerpContent } from '@/utils/approval/serpDocument';
import type { ContentExtraProps } from '../../types';
import { ContentSlotRoot } from '../styles';

/** 159 SERP 시즌운영계획 — 저장 content 그대로(레거시 조회와 동일), 「상세 보기」 접고 펴기만 포탈 버튼 */
const SerpSeasonPlanSlot = ({ data }: ContentExtraProps) => {
  const content = parseSerpContent(data.attributes);
  if (!content) return null;
  return (
    <ContentSlotRoot>
      <SerpSeasonPlanSnapshot content={content} />
    </ContentSlotRoot>
  );
};

export default SerpSeasonPlanSlot;
